import { useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { GET_CATALOG_RESOURCES_QUERY } from '../../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService.dfc';
const toCatalogCardModelsRequest = ({
  id,
  type,
  language: requestedLanguage
}) => {
  let language;
  if (type === 'TRACK' || type === 'LESSON') {
    language = requestedLanguage === null || requestedLanguage === void 0 ? void 0 : requestedLanguage.toLowerCase();
  }
  return {
    resourceId: id,
    language,
    type
  };
};
export const useCatalogCardModels = ({
  items,
  skip
}) => {
  const {
    data,
    loading: catalogCardModelsLoading,
    error: catalogCardModelsError,
    apolloError
  } = useQuery(GET_CATALOG_RESOURCES_QUERY, {
    variables: {
      requestedResources: items
      // filter out tracks and lessons with no language (bad data)
      .filter(({
        type,
        language
      }) => language || type === 'SHORT_FORM_CONTENT' || type === 'PLAYLIST').map(toCatalogCardModelsRequest)
    },
    skip: skip || !items.length
  });
  return {
    catalogCardModels: data === null || data === void 0 ? void 0 : data.results,
    catalogCardModelsLoading,
    catalogCardModelsError,
    apolloError
  };
};